import React from 'react'

import { type MetricMap } from './index'

export const Topology: React.FC<{
  metrics: MetricMap
}> = ({ metrics }) => {
  const tidbCount =
    Math.round(metrics['TiDB_count:total']?.values.max?.value) || 0
  const tikvCount =
    Math.round(metrics['TiKV_count:total']?.values.max?.value) || 0
  const pdCount = Math.round(metrics['PD_count:total']?.values.max?.value) || 0
  const tiflashCount =
    Math.round(metrics['TiFlash_count:total']?.values.max?.value) || 0
  return (
    <>
      <h1 className='mt-6'>2. Topology</h1>
      <table className='border-collapse'>
        <thead>
          <tr>
            <th className='text-left bg-[#fafafa] px-2 py-1 border-r border-solid border-[#f0f0f0]'>
              No.
            </th>
            <th className='text-left bg-[#fafafa] px-2 py-1 border-r border-solid border-[#f0f0f0]'></th>
            <th className='text-left bg-[#fafafa] px-2 py-1 border-r border-solid border-[#f0f0f0]'>
              Value
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className='px-2 py-1 border-r border-solid border-[#f0f0f0]'>
              1
            </td>
            <td className='px-2 py-1 border-r border-solid border-[#f0f0f0]'>
              Database configuration
            </td>
            <td className='px-2 py-1 border-r border-solid border-[#f0f0f0]'>
              {`${tidbCount} TiDBs + ${tikvCount} TiKVs + ${pdCount} PDs + ${tiflashCount} TiFlash`}
            </td>
          </tr>
          <tr>
            <td className='px-2 py-1 border-r border-solid border-[#f0f0f0]'>
              2
            </td>
            <td className='px-2 py-1 border-r border-solid border-[#f0f0f0]'>
              TiKV's machine type
            </td>
            <td className='px-2 py-1 border-r border-solid border-[#f0f0f0]'>
              {'[manual] check by Nodes-Info --> Instance type'}
            </td>
          </tr>
          <tr>
            <td className='px-2 py-1 border-r border-solid border-[#f0f0f0]'>
              3
            </td>
            <td className='px-2 py-1 border-r border-solid border-[#f0f0f0]'>
              Node Topology
              <br />
              {`Check by TiDB Dashboard --> Cluster Info`}
            </td>
            <td className='px-2 py-1 border-r border-solid border-[#f0f0f0]'>
              Checklist:
              <br />
              1. Version: if hotfix version
              <br />
              2. Up Time(uptime)：If exist service startup long time(e.g. 6
              months) ago, or just startup.
              <br />
              3. hosts：Check CPU count and memory size， e.g. 8C64GB. This is
              for later section7 capacity/resource status review.
              <br />
              {
                '4. CPU Usage：check if any higher value on system% ,e.g. >10%. '
              }
              <br />
              5. Storage Topology: <br />
              <span className='ml-4'>
                a. check if imbalance allocation of nodes between zones.
              </span>
              <br />
              <span className='ml-4'>
                b. TiFlash: check if multiple AZs configuration.
              </span>
              <br />
            </td>
          </tr>
        </tbody>
      </table>
    </>
  )
}
